import { api } from "../api";

export const onboardingApi = {
    getStatus: async () => {
        const { data } = await api.get("/onboarding/status");
        return data;
    },

    markSeen: async (conversationId: string) => {
        await api.post("/onboarding/mark-seen", { conversation_id: conversationId });
    },

    submitAnswer: async (
        conversationId: string,
        content: string,
        files?: File[],
        audio?: File,
        audioDuration?: number,
        onUploadProgress?: (progress: number) => void,
        transcribePending?: boolean,
    ) => {
        const formData = new FormData();
        formData.append("conversation_id", conversationId);
        if (content) formData.append("content", content);
        if (audioDuration) {
            formData.append("audio_duration", audioDuration.toString());
        }
        if (transcribePending) {
            formData.append("transcribe_pending", "true");
        }

        if (files) {
            files.forEach((file) => {
                formData.append("files", file);
            });
        }

        if (audio) {
            formData.append("audio", audio);
        }

        const config: Record<string, unknown> = {
            timeout: 300_000, // 5 min for large audio uploads
            adapter: 'xhr',  // Force XMLHttpRequest — fetch adapter doesn't support onUploadProgress
        };
        if (onUploadProgress) {
            config.onUploadProgress = (progressEvent: { loaded: number; total?: number }) => {
                const total = progressEvent.total;
                if (total && total > 0) {
                    // Cap at 99% — let completion set 100%
                    const percent = Math.min(
                        Math.round((progressEvent.loaded * 100) / total),
                        99,
                    );
                    onUploadProgress(percent);
                }
            };
        }

        const { data } = await api.post("/onboarding/answer", formData, config);
        return data;
    },

    complete: async () => {
        const { data } = await api.post("/onboarding/complete");
        return data;
    },
};
